
import React from "react";

type ContributorSectionProps = {
  title: string;
  contributors: string[][];
};

const ContributorSection: React.FC<ContributorSectionProps> = ({ title, contributors }) => {
  return (
    <div>
      <h3 className="font-semibold text-lg mb-4 text-center">{title}</h3>
      <ul>
        {contributors.map((contributor, index) => (
          <li key={index} className="mb-2 text-center">
            <span className="font-medium">{contributor[0]}</span>
            {title !== "Report Authors" && contributor[1] && <span className="text-gray-600"> - {contributor[1]}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
};

const Contributors: React.FC = () => {
  const authorsData = [
    ["Utkarsh Sharma", "Vlinder Inc."],
    ["Arjun Bahuguna", "Audio Realities"],
  ];

  const advisorsData = [
    ["Suresh J", ""],
  ];

  const technicalData = [
    ["Aniket Rajgarhia", ""],
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
      <ContributorSection title="Report Authors" contributors={authorsData} />
      <ContributorSection title="Industry Advisors" contributors={advisorsData} />
      <ContributorSection title="Technical Contributors" contributors={technicalData} />
    </div>
  );
};

export default Contributors;
